import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CaseService } from '../../../../services/case.services';
import { firstValueFrom } from 'rxjs';

export interface ICerebralVisit1 {
  hospitalDistrict: string;
  doctorName: string;
  department: string;
  visitDate: string;

  diagnosis: string;
  complaint: string;
  history: string;
  medicalHistoryNote: string;

  smokingUsage: string;
  alcoholUsage: string;
  allergies: string;
  chronicDiseases: string;

  surgery: string;
  surgeryHistory: string;
  familyHistoryNote: string;

  examinationControlNote: string;
  testRecommendation: string;
  consultation: string;

  treatmentNote: string;
  continuousMedications: string;
  prescription: string;
}
export interface ICerebralVisit {
  date: string;
  facilityName: string;
  serviceName: string;
  doctorName: string;

  diagnosis: string;
  complaint: string;
  story: string;
  resumeNote: string;

  smokingUsageInformation: string;
  alcoholUseInformation: string;

  allergies: string;
  chronicDiseases: string;

  surgicalHistory: string;
  injuryHistory: string;
  familyHistoryNote: string;

  inspectionNote: string;
  controlNote: string;
  investigationRecommendation: string;

  consultation: {
    requestedDoctor: string;
    desiredSituation: string;
    requestedSection: string;
  };

  treatmentNote: string;
  medicationsTakesRegularly: string;
  prescriptions: string;

  applicationMovements: string[];
}

@Component({
  selector: 'app-cerebral-informations',
  templateUrl: './cerebral-informations.component.html',
  styleUrls: ['./cerebral-informations.component.scss'],
})
export class CerebralInformationsComponent implements OnInit {
  @Input() patientId: number | null;
  @Input() caseId: number |null;

  visits: ICerebralVisit[] = [];
  filteredVisits: ICerebralVisit[] = [];
  selectedVisit: ICerebralVisit | null = null;
  searchText: string = '';

  loading: boolean = false;
  isSuccess: boolean = false;
  constructor(private sanitizer: DomSanitizer,
    private readonly caseService: CaseService
  ) { }

  ngOnInit(): void {
    console.log(this.caseId, this.patientId)
    // this.visits = [
    //   {
    //     hospitalDistrict: 'Ataşehir',
    //     doctorName: 'Dr. Özgür Cengoler',
    //     department: 'İç Hastalıkları',
    //     visitDate: '11.03.2026',
    //     diagnosis: 'J06.9 Akut Üst Solunum Yolu Enfeksiyonu',
    //     complaint: 'Öksürük, baş ağrısı ve halsizlik',
    //     history: 'Hasta 3 gündür halsizlik sonrası bugün polikliniğe başvurmuş, 38 ateş',
    //     medicalHistoryNote: 'Daha önce CA geçirmiş',
    //     smokingUsage: 'Kullanıyor',
    //     alcoholUsage: 'Aralıklı kullanıyor',
    //     allergies: 'Yok',
    //     chronicDiseases: 'Tansiyon',
    //     surgery: '',
    //     surgeryHistory: 'Kolon CA',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Ateş 38 ölçüldü, boğaz hiperemik',
    //     testRecommendation: 'Hemogram, CRP, Sodyum, Potasyum',
    //     consultation: '',
    //     treatmentNote: 'İlaç reçete edildi',
    //     continuousMedications: 'Parol, Aferin',
    //     prescription: 'S85SJE',
    //   },
    //   {
    //     hospitalDistrict: 'Atakent',
    //     doctorName: 'Prof. Dr. Fatma Gün',
    //     department: 'Kadın Hastalıkları ve Doğum',
    //     visitDate: '05.02.2026',
    //     diagnosis: 'Demir eksikliği',
    //     complaint: 'Halsizlik',
    //     history: 'Son 1 haftadır yorgunluk şikayeti mevcut.',
    //     medicalHistoryNote: 'Önceden kansızlık öyküsü var',
    //     smokingUsage: '',
    //     alcoholUsage: '',
    //     allergies: 'Penisilin',
    //     chronicDiseases: 'Anemi',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: 'Ailede diyabet öyküsü var',
    //     examinationControlNote: 'Genel durum iyi',
    //     testRecommendation: 'Hemogram, ferritin',
    //     consultation: 'Dahiliye önerildi',
    //     treatmentNote: 'Demir ilacı başlandı',
    //     continuousMedications: 'Demir hapı',
    //     prescription: 'RX-2026-15',
    //   },
    //   {
    //     hospitalDistrict: 'Kozyatağı',
    //     doctorName: 'Dr. Ahmet Kara',
    //     department: 'Göz Hastalıkları',
    //     visitDate: '08.01.2026',
    //     diagnosis: 'Alerjik konjonktivit',
    //     complaint: 'Göz kızarıklığı',
    //     history: 'Mevsimsel artış gösteriyor',
    //     medicalHistoryNote: '',
    //     smokingUsage: '',
    //     alcoholUsage: '',
    //     allergies: 'Polen',
    //     chronicDiseases: '',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Gözde sulanma mevcut',
    //     testRecommendation: '',
    //     consultation: '',
    //     treatmentNote: 'Damla verildi',
    //     continuousMedications: 'Göz damlası',
    //     prescription: 'GOZ-55',
    //   },
    //   // --- YENİ EKLENEN KAYITLAR ---
    //   {
    //     hospitalDistrict: 'Kadıköy',
    //     doctorName: 'Uzm. Dr. Selin Yılmaz',
    //     department: 'Kardiyoloji',
    //     visitDate: '20.12.2025',
    //     diagnosis: 'Esansiyel Hipertansiyon',
    //     complaint: 'Çarpıntı ve enseden gelen baş ağrısı',
    //     history: 'Efor sarf ettiğinde nefes darlığı yaşıyor.',
    //     medicalHistoryNote: 'Hipertansiyon tanısı 2 yıl önce konmuş',
    //     smokingUsage: 'Bırakmış',
    //     alcoholUsage: 'Yok',
    //     allergies: 'Yok',
    //     chronicDiseases: 'Hipertansiyon',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: 'Babada kalp krizi öyküsü',
    //     examinationControlNote: 'TA: 150/95 mmHg, kalp sesleri normal',
    //     testRecommendation: 'EKG, Eko, Lipid Paneli',
    //     consultation: '',
    //     treatmentNote: 'İlaç dozu revize edildi',
    //     continuousMedications: 'Diltizem',
    //     prescription: 'KRD-992',
    //   },
    //   {
    //     hospitalDistrict: 'Beşiktaş',
    //     doctorName: 'Dr. Murat Can',
    //     department: 'Ortopedi ve Travmatoloji',
    //     visitDate: '15.11.2025',
    //     diagnosis: 'Lumbal Disk Hernisi (Bel Fıtığı)',
    //     complaint: 'Belden bacağa vuran ağrı',
    //     history: 'Ağır kaldırma sonrası ani başlayan ağrı.',
    //     medicalHistoryNote: '',
    //     smokingUsage: 'Kullanıyor',
    //     alcoholUsage: 'Yok',
    //     allergies: 'Yok',
    //     chronicDiseases: '',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Lasegue testi pozitif (+)',
    //     testRecommendation: 'Bel MR (Lomber MR)',
    //     consultation: 'Fizik Tedavi',
    //     treatmentNote: 'İstirahat ve NSAİİ ilaçlar',
    //     continuousMedications: 'Muscoril, Dikloron',
    //     prescription: 'ORT-112',
    //   },
    //   {
    //     hospitalDistrict: 'Üsküdar',
    //     doctorName: 'Dr. Ayşe Demir',
    //     department: 'Dermatoloji',
    //     visitDate: '02.11.2025',
    //     diagnosis: 'Atopik Dermatit',
    //     complaint: 'Ciltte kuruluk ve kaşıntı',
    //     history: 'Soğuk havalarda şikayetleri artıyor.',
    //     medicalHistoryNote: '',
    //     smokingUsage: '',
    //     alcoholUsage: '',
    //     allergies: 'Toz, nikel',
    //     chronicDiseases: 'Alerjik Astım',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Ekstremitelerde yer yer plaklar mevcut',
    //     testRecommendation: 'Prick Testi',
    //     consultation: '',
    //     treatmentNote: 'Nemlendirici ve topikal steroid',
    //     continuousMedications: 'Advantan pomad',
    //     prescription: 'DER-44',
    //   },
    //   {
    //     hospitalDistrict: 'Şişli',
    //     doctorName: 'Prof. Dr. Kemal Sunal',
    //     department: 'Kulak Burun Boğaz',
    //     visitDate: '10.10.2025',
    //     diagnosis: 'Deviasyon ve Kronik Sinüzit',
    //     complaint: 'Burun tıkanıklığı, horlama',
    //     history: 'Çocukluktan beri süregelen nefes alma problemi.',
    //     medicalHistoryNote: '',
    //     smokingUsage: 'Yok',
    //     alcoholUsage: 'Yok',
    //     allergies: 'Yok',
    //     chronicDiseases: '',
    //     surgery: 'Septoplasti planlandı',
    //     surgeryHistory: '',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Septum sola devie, konka hipertrofisi',
    //     testRecommendation: 'Paranazal Sinüs BT',
    //     consultation: '',
    //     treatmentNote: 'Cerrahi operasyon için gün verildi',
    //     continuousMedications: 'Nasonex sprey',
    //     prescription: 'KBB-78',
    //   },
    //   {
    //     hospitalDistrict: 'Maltepe',
    //     doctorName: 'Dr. Canan Karatay',
    //     department: 'Endokrinoloji',
    //     visitDate: '25.09.2025',
    //     diagnosis: 'İnsülin Direnci',
    //     complaint: 'Kilo verememe, yemek sonrası uyku hali',
    //     history: 'Son 6 ayda 8 kilo artışı.',
    //     medicalHistoryNote: '',
    //     smokingUsage: 'Yok',
    //     alcoholUsage: 'Yok',
    //     allergies: 'Yok',
    //     chronicDiseases: 'Haşimato Tiroiditi',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: 'Anne Tip 2 Diyabet',
    //     examinationControlNote: 'Bel çevresi genişlemiş, Acanthosis Nigricans izlendi',
    //     testRecommendation: 'HOMA-IR, HbA1c, TSH',
    //     consultation: 'Diyetisyen',
    //     treatmentNote: 'Metformin tedavisine başlandı',
    //     continuousMedications: 'Glifor, Euthyrox',
    //     prescription: 'END-001',
    //   },
    //   {
    //     hospitalDistrict: 'Bakırköy',
    //     doctorName: 'Uzm. Dr. Hakan Yılmaz',
    //     department: 'Nöroloji',
    //     visitDate: '12.08.2025',
    //     diagnosis: 'Migren',
    //     complaint: 'Tek taraflı şiddetli baş ağrısı, ışığa duyarlılık',
    //     history: 'Ayda 3-4 kez atak geçiriyor.',
    //     medicalHistoryNote: '',
    //     smokingUsage: 'Yok',
    //     alcoholUsage: 'Aralıklı',
    //     allergies: 'Yok',
    //     chronicDiseases: '',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: 'Teyzede migren öyküsü',
    //     examinationControlNote: 'Nörolojik muayene doğal',
    //     testRecommendation: 'Beyin MR (Normal)',
    //     consultation: '',
    //     treatmentNote: 'Atak ve profilaksi tedavisi düzenlendi',
    //     continuousMedications: 'Relpax, Sibelius',
    //     prescription: 'NOR-22',
    //   },
    //   {
    //     hospitalDistrict: 'Kartal',
    //     doctorName: 'Dr. Mehmet Öz',
    //     department: 'Göğüs Hastalıkları',
    //     visitDate: '05.07.2025',
    //     diagnosis: 'Akut Bronşit',
    //     complaint: 'Hırıltılı solunum, balgam',
    //     history: 'Geçirilen grip sonrası geçmeyen öksürük.',
    //     medicalHistoryNote: '',
    //     smokingUsage: 'Kullanıyor (1 paket/gün)',
    //     alcoholUsage: 'Yok',
    //     allergies: 'Aspirin',
    //     chronicDiseases: 'KOAH başlangıcı',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Ral ve ronküs duyuldu',
    //     testRecommendation: 'SFT (Solunum Fonksiyon Testi), Akciğer Grafisi',
    //     consultation: '',
    //     treatmentNote: 'Antibiyotik ve inhaler başlandı',
    //     continuousMedications: 'Ventolin',
    //     prescription: 'GOG-66',
    //   },
    //   {
    //     hospitalDistrict: 'Sarıyer',
    //     doctorName: 'Uzm. Dr. Elif Akın',
    //     department: 'Gastroenteroloji',
    //     visitDate: '18.06.2025',
    //     diagnosis: 'Gastroözofageal Reflü',
    //     complaint: 'Midede yanma ve ağıza acı su gelmesi',
    //     history: 'Baharatlı gıdalar sonrası şikayetler artıyor.',
    //     medicalHistoryNote: 'H. Pylori tedavisi görmüş (2023)',
    //     smokingUsage: 'Yok',
    //     alcoholUsage: 'Yok',
    //     allergies: 'Yok',
    //     chronicDiseases: '',
    //     surgery: '',
    //     surgeryHistory: 'Safra Kesesi Ameliyatı (2020)',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Epigastrik hassasiyet mevcut',
    //     testRecommendation: 'Endoskopi (Gastroskopi)',
    //     consultation: '',
    //     treatmentNote: 'PPI grubu ilaç başlandı, diyet önerildi',
    //     continuousMedications: 'Nexium',
    //     prescription: 'GAS-33',
    //   },
    //   {
    //     hospitalDistrict: 'Fatih',
    //     doctorName: 'Dr. Bülent Ecevit',
    //     department: 'Üroloji',
    //     visitDate: '30.05.2025',
    //     diagnosis: 'Nefrolitiazis (Böbrek Taşı)',
    //     complaint: 'Yan ağrısı, idrarda yanma',
    //     history: 'Daha önce de taş düşürme öyküsü var.',
    //     medicalHistoryNote: '',
    //     smokingUsage: 'Yok',
    //     alcoholUsage: 'Yok',
    //     allergies: 'Yok',
    //     chronicDiseases: '',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: 'Kardeşinde böbrek taşı var',
    //     examinationControlNote: 'Kostovertebral açı hassasiyeti (+)',
    //     testRecommendation: 'Tüm Batın USG, Tam İdrar Tetkiki',
    //     consultation: '',
    //     treatmentNote: 'Bol sıvı alımı ve antispazmodik önerildi',
    //     continuousMedications: 'Buscopan Plus',
    //     prescription: 'URO-88',
    //   },
    //   {
    //     hospitalDistrict: 'Pendik',
    //     doctorName: 'Dr. Zeynep Korkmaz',
    //     department: 'Psikiyatri',
    //     visitDate: '14.04.2025',
    //     diagnosis: 'Yaygın Anksiyete Bozukluğu',
    //     complaint: 'Uyku bozukluğu, sürekli endişe hali',
    //     history: 'İş stresi nedeniyle son 3 aydır artan belirtiler.',
    //     medicalHistoryNote: '',
    //     smokingUsage: 'Kullanıyor',
    //     alcoholUsage: 'Aralıklı',
    //     allergies: 'Yok',
    //     chronicDiseases: '',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Anksiyöz ruh hali gözlendi',
    //     testRecommendation: 'Beck Anksiyete Ölçeği',
    //     consultation: 'Psikolog - Terapi',
    //     treatmentNote: 'SSRI grubu ilaç başlandı',
    //     continuousMedications: 'Selectra',
    //     prescription: 'PSI-101',
    //   },
    //   {
    //     hospitalDistrict: 'Beylikdüzü',
    //     doctorName: 'Uzm. Dr. Deniz Gezmiş',
    //     department: 'Enfeksiyon Hastalıkları',
    //     visitDate: '22.03.2025',
    //     diagnosis: 'Üner Sistem Enfeksiyonu (İYE)',
    //     complaint: 'Sık idrara çıkma, ateş',
    //     history: '2 gündür devam eden şikayetler.',
    //     medicalHistoryNote: '',
    //     smokingUsage: 'Yok',
    //     alcoholUsage: 'Yok',
    //     allergies: 'Sulfa grubu ilaçlar',
    //     chronicDiseases: '',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Ateş 37.8, hassasiyet mevcut',
    //     testRecommendation: 'İdrar Kültürü, Antibiogram',
    //     consultation: '',
    //     treatmentNote: 'Kültür sonucuna göre antibiyotik düzenlenecek',
    //     continuousMedications: 'Piyeloseptyl',
    //     prescription: 'ENF-41',
    //   },
    //   {
    //     hospitalDistrict: 'Zeytinburnu',
    //     doctorName: 'Dr. Haluk Bilginer',
    //     department: 'Fizik Tedavi ve Rehabilitasyon',
    //     visitDate: '05.02.2025',
    //     diagnosis: 'Lateral Epikondilit (Tenisçi Dirseği)',
    //     complaint: 'Dirsek dış kısmında ağrı ve güç kaybı',
    //     history: 'Sürekli bilgisayar kullanımı sonrası gelişen ağrı.',
    //     medicalHistoryNote: '',
    //     smokingUsage: 'Yok',
    //     alcoholUsage: 'Yok',
    //     allergies: 'Yok',
    //     chronicDiseases: '',
    //     surgery: '',
    //     surgeryHistory: '',
    //     familyHistoryNote: '',
    //     examinationControlNote: 'Cozen testi pozitif',
    //     testRecommendation: 'Dirsek USG',
    //     consultation: 'Ergoterapi',
    //     treatmentNote: 'Epikondilit bandajı ve egzersiz programı',
    //     continuousMedications: 'Voltaren Emulgel',
    //     prescription: 'FTR-202',
    //   }
    // ];
    this.loadData()
  }

  async loadData() {
    this.loading = true;
    const response: any = await firstValueFrom(
      this.caseService.getCerebralPatientInformations(
        this.patientId,
        this.caseId,
      )
    );
    //responce.ReturnCode || responce.ReturnMessage !responce.IsSuccessed
    this.isSuccess = response?.isSuccess ?? false;
    this.visits = (response?.PatientApplicationSummaries || []).map((item: any) => ({
      date: item.Date,
      facilityName: item.FacilityName,
      serviceName: item.ServiceName,
      doctorName: item.DoctorName,

      diagnosis: item.Diagnosis,
      complaint: item.Complaint,
      story: item.Story,
      resumeNote: item.ResumeNote,

      smokingUsageInformation: item.SmokingUsageInformation,
      alcoholUseInformation: item.AlcoholUseInformation,

      allergies: item.Allergies,
      chronicDiseases: item.ChronicDiseases,

      surgicalHistory: item.SurgicalHistory,
      injuryHistory: item.InjuryHistory,
      familyHistoryNote: item.FamilyHistoryNote,

      inspectionNote: item.InspectionNote,
      controlNote: item.ControlNote,
      investigationRecommendation: item.InvestigationRecommendation,

      consultation: {
        requestedDoctor:
          item.Consultation?.RequestedDoctor || '',
        desiredSituation:
          item.Consultation?.DesiredSituation || '',
        requestedSection:
          item.Consultation?.RequestedSection || '',
      },

      treatmentNote: item.TreatmentNote,
      medicationsTakesRegularly:
        item.MedicationsTakesRegularly,

      prescriptions: item.Prescriptions,

      applicationMovements:
        item.ApplicationMovements || [],
    }));

    this.filteredVisits = [...this.visits];
    this.selectedVisit = this.filteredVisits[0] || null;
    this.loading = false;
  }

  
  selectVisit(visit: ICerebralVisit) {
    this.selectedVisit = visit;
  }

  onSearchChange() {
    const term = this.searchText.trim().toLocaleLowerCase('tr');

    if (!term) {
      this.filteredVisits = [...this.visits];

      if (
        this.selectedVisit &&
        !this.filteredVisits.includes(this.selectedVisit)
      ) {
        this.selectedVisit = this.filteredVisits[0] || null;
      }

      if (!this.selectedVisit && this.filteredVisits.length > 0) {
        this.selectedVisit = this.filteredVisits[0];
      }

      return;
    }

    this.filteredVisits = this.visits.filter((visit) =>
      this.visitMatchesSearch(visit, term)
    );

    if (
      !this.selectedVisit ||
      !this.filteredVisits.some((x) => x === this.selectedVisit)
    ) {
      this.selectedVisit = this.filteredVisits[0] || null;
    }
  }

   private visitMatchesSearch(
    visit: ICerebralVisit,
    term: string,
  ): boolean {
    const consultationText = [
      visit.consultation?.requestedDoctor,
      visit.consultation?.requestedSection,
      visit.consultation?.desiredSituation,
    ].join(' ');

    const searchableFields = [
      visit.date,
      visit.facilityName,
      visit.serviceName,
      visit.doctorName,

      visit.diagnosis,
      visit.complaint,
      visit.story,
      visit.resumeNote,

      visit.smokingUsageInformation,
      visit.alcoholUseInformation,

      visit.allergies,
      visit.chronicDiseases,

      visit.surgicalHistory,
      visit.injuryHistory,
      visit.familyHistoryNote,

      visit.inspectionNote,
      visit.controlNote,
      visit.investigationRecommendation,

      visit.treatmentNote,
      visit.medicationsTakesRegularly,
      visit.prescriptions,

      consultationText,

      ...(visit.applicationMovements || []),
    ];

    return searchableFields.some((field) =>
      (field || '')
        .toLocaleLowerCase('tr')
        .includes(term),
    );
  }

  highlight(text: string | null | undefined): SafeHtml {
    const value = text || '-';
    const term = this.searchText.trim();

    if (!term) {
      return this.sanitizer.bypassSecurityTrustHtml(this.escapeHtml(value));
    }

    const escapedText = this.escapeHtml(value);
    const escapedSearch = this.escapeRegex(term);

    const regex = new RegExp(`(${escapedSearch})`, 'gi');
    const highlighted = escapedText.replace(
      regex,
      `<mark class="cerebral-highlight">$1</mark>`
    );

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }

  private escapeRegex(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}